import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFlag2"><Path d="M4.75 15.0831V4.39891C4.75 4.01841 4.96525 3.66459 5.31895 3.52431C9.78767 1.75201 13.3875 5.38531 17.7409 4.33038C18.4613 4.1558 19.25 4.64565 19.25 5.38694V14.4618C19.25 14.8423 19.0348 15.1961 18.6811 15.3363C13.7067 17.3092 9.809 12.5839 4.75 15.0831ZM4.75 15.0831V21.2498" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFlag2;
